import { popupTypes, inviteTypes, teamTypes } from '../actions'
import { Auth } from '../helpers'

const initialState = {
  payload: {},
  showApplyTeam: false,
  showInvitePlayer: false,
  showNotification: false,
  showEmailInvite: false,
  showLeaveHackathon: false,
  showSendNotif: false,
  showDeleteTeam: false,
  showTeamsInfo: false,
  showEditAnswer: false,
  showAnswerToQuestion: false,
  showAdminAnswerEdit: false,
  showAddPoll: false,
  showVotes: false,
  showUniqueVotes: false,
  errors: ''
}

const popup = (state = initialState, action) => {
  switch (action.type) {
    case popupTypes.SWITCH_APPLY_TEAM:
      return {
        ...state,
        showApplyTeam: !state.showApplyTeam,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_ADMIN_ANSWER_EDIT:
      return {
        ...state,
        showAdminAnswerEdit: !state.showAdminAnswerEdit,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_ANSWER_TO_QUESTION:
      return {
        ...state,
        showAnswerToQuestion: !state.showAnswerToQuestion,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_EDIT_ANSWER:
      return {
        ...state,
        showEditAnswer: !state.showEditAnswer,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_INVITE_PLAYER:
      return {
        ...state,
        showInvitePlayer: !state.showInvitePlayer,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_NOTIFICATION:
      return {
        ...state,
        showNotification: !state.showNotification,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_EMAIL_INVITE:
      return {
        ...state,
        showEmailInvite: !state.showEmailInvite,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_SEND_NOTIF:
      return {
        ...state,
        showSendNotif: !state.showSendNotif,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_DELETE_TEAM:
      return {
        ...state,
        showDeleteTeam: !state.showDeleteTeam
      }
    case inviteTypes.EMAIL_INVITE_FAIL: {
      return {
        ...state,
        errors: action.payload ? action.payload.error : 'Server connection error!'
      }
    }
    case inviteTypes.EMAIL_INVITE_SUCCESS:
      return {
        ...state,
        showEmailInvite: false
      }
    case popupTypes.SWITCH_LEAVE_HACKATHON:
      return {
        ...state,
        showLeaveHackathon: !state.showLeaveHackathon
      }
    case popupTypes.SWITCH_TEAMS_INFO:
      return {
        ...state,
        showTeamsInfo: !state.showTeamsInfo,
        payload: action.payload || {}
      }
    case 'socket/UPDATED_COMMENT':
      return initialState
    case 'socket/ANSWERED_COMMENT':
      return {
        ...state,
        showAnswerToQuestion: false
      }
    case 'socket/EDIT_ANSWERED_COMMENT':
      return {
        ...state,
        showAdminAnswerEdit: false
      }
    case popupTypes.SWITCH_ADD_POLL:
      return {
        ...state,
        showAddPoll: !state.showAddPoll,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_SHOW_VOTES:
      return {
        ...state,
        showVotes: !state.showVotes,
        payload: action.payload || {}
      }
    case popupTypes.SWITCH_UNIQUE_VOTES:
      return {
        ...state,
        showUniqueVotes: !state.showUniqueVotes,
        payload: action.payload || {}
      }
    case 'socket/ADD_NEW_QAPOLLS':
      if (action.payload.payload.type === 'poll' && action.payload.payload.participant.id === Auth.getParticipant()) {
        return {
          ...state,
          showAddPoll: !state.showAddPoll
        }
      }
      return state
    case teamTypes.UPDATE:
      let objClone = { ...state.payload }
      if (objClone.teams) {
        let teamsClone = [...objClone.teams]
        let index = teamsClone.findIndex(t => t.id === action.team.id)
        if (index > -1) {
          teamsClone[index] = action.team
        }
        objClone.teams = teamsClone
      }
      return {
        ...state,
        payload: objClone
      }
    default: return state
  }
}

export default popup



// WEBPACK FOOTER //
// ./src/reducers/popup.js